module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectIcon-tab"
  }, [_c('div', {
    staticClass: "selectIcon-left fa fa-caret-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-icon-blue fz-30 ovf-hd"
  }, _vm._l((_vm.icons), function(item) {
    return _c('div', {
      staticClass: "w-30 h-30 pointer fl selectIcon-margin m-b-10",
      class: item.name,
      on: {
        "click": function($event) {
          _vm.selectIcon(item.name)
        }
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57f6fe44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/abstract/selectIcon.vue
// module id = 1870
// module chunks = 2